import { createDefaultPivotConfig as createDefaultPivotConfig_grouped } from './groupedbarchartUtils'
import { isAddable } from './index.js'
export function createDefaultPivotConfig(dimensions) {
  return createDefaultPivotConfig_grouped(dimensions)
}

export function getAvailability(dimensions, dataCard) {
  let unit = dataCard.data[0].unit
  let metas = Object.values(dimensions.dimensionMetas)
  let hasExtraDims = metas.filter(d => d.type !== 'time' && d.type !== 'location').length > 0
  return { enabled: hasExtraDims && isAddable(unit), enableable: hasExtraDims && isAddable(unit) }
  //return { enabled: true, enableable: true }
}
export default {
  getAvailability,
  createDefaultPivotConfig,
  maxChartDims: 2,
  maxRowDims: 1,
  sdvComponent: 'StackedBars',
}
